import "./App.css?v=5";
import SitePet from "./SitePet";
import Sidebar from "./SideBar";
import ProjectSection from "./ProjectCard";
import PortfolioFooter from "./PortfolioFooter";
import ActivityLog from "./ActivityLog";

function FeaturedProjects() {
  return (
    <div>
      <div className="screen-1">
        <Sidebar />

        <div className="content-1">
           <ActivityLog page="featured" />
            {/* <ActivityLog page="case-study" />
            <ActivityLog page="blogs" /> */}

          <ProjectSection filter="featured" />
        </div>
      </div>

      <div
        className="frame6"
        data-platform
        data-pet-message="Contact zone reached. I will wave politely."
      >
        <PortfolioFooter />
      </div>

      <SitePet />
    </div>
  );
}

export default FeaturedProjects;
